export default __webpack_public_path__ + "static/media/C98-BNB.74ed7c40.svg";